import axios from "axios";

const GANDALF_TOKEN_KEY = "gandalfToken";

export const gandalfAuth = {
    /**
     * Get Gandalf token from localStorage
     */
    getToken(): string | null {
        return localStorage.getItem(GANDALF_TOKEN_KEY);
    },

    /**
     * Set Gandalf token in localStorage
     */
    setToken(token: string): void {
        localStorage.setItem(GANDALF_TOKEN_KEY, token);
    },

    /**
     * Clear Gandalf token from localStorage
     */
    clearToken(): void {
        localStorage.removeItem(GANDALF_TOKEN_KEY);
    },

    /**
     * Check if Gandalf token exists
     */
    hasToken(): boolean {
        return !!this.getToken();
    },

    /**
     * Validate token with backend
     * Returns true if token is valid, false otherwise
     */
    async validateToken(): Promise<boolean> {
        // Skip validation in production
        if (process.env.REACT_APP_ENV === "production") {
            return true;
        }

        const token = this.getToken();
        if (!token) {
            return false;
        }

        try {
            // Make a request to the dedicated validation endpoint
            const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
            await axios.post(
                `${backendUrl}/validate-gandalf-token`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return true;
        } catch (error: any) {
            // If we get 401, token is invalid
            if (error.response?.status === 401) {
                this.clearToken();
                return false;
            }
            // Other errors (network, etc.) - assume token might be valid
            return true;
        }
    },
};
